import { z } from 'zod';
import { defineEndpoint } from '../define';

export const deleteUser = defineEndpoint({
  method: 'DELETE',
  path: '/v1/users/:userId',
  params: z.object({ userId: z.string().uuid() }),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({}),
  successStatus: 204,
});
